module.exports = __webpack_public_path__ + "files/416cfbb507c55b32eb364854a4cdad83.png";